import { TextLine } from 'Components/lines/text-line/TextLine';
export default TextLine;
